<button-wrapper #animationRoot>
  <button *ngIf="!href"
    [attr.id]="htmlId"
    [type]="btnType"
    [ngClass]="{
      'btn-lg': btnSize === 'large',
      'btn-sm': btnSize === 'small',
      'btn-block': btnSize === 'block',
      'btn-link': btnType === 'link'
    }"
    [disabled]="disabled"
    (click)="onClick()"
    role="button"
    class="wvr-components wvr-button btn {{btnType!=='link' ? 'btn-' + themeVariant : ''}}">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </button>
  <a *ngIf="href"
    [attr.id]="htmlId"
    [attr.href]="disabled ? undefined : href"
    [ngClass]="{
      'btn-lg': btnSize === 'large',
      'btn-sm': btnSize === 'small',
      'btn-block': btnSize === 'block',
      'btn-link': btnType === 'link',
      'disabled': disabled
    }"
    role="button"
    aria-label="button"
    class="wvr-components wvr-button btn {{btnType!=='link' ? 'btn-' + themeVariant : ''}}">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </a>
</button-wrapper>

<ng-template #content>
  <span button-content>
    <ng-content select="template[button-content]"></ng-content>
  </span>
  {{btnTxt}}
</ng-template>
